import { UPLOAD } from '../actions/upload';
import { CANCEL_UPLOADS } from '../actions/cancel-uploads';
import { setIsLoading } from '../actions/set-is-loading';

export default function uploadMiddleware(uploadFile, requestCredentials, request) {
  let requests = [];
  const removeFinishedRequests = store => () => {
    requests = requests.filter(xhr => xhr.readyState !== 4);
    if (!requests.length) {
      // Needed for decoratePostFormProps
      store.dispatch(setIsLoading('upload', '', false));
    }
  };

  return store => next => action => {
    switch (action.type) {
      case UPLOAD: {
        const { file, type, onSuccess } = action.payload;
        // Needed for decoratePostFormProps
        store.dispatch(setIsLoading('upload', '', true));

        return requestCredentials(request, type)
          .then(credentials => {
            const { xhr, promise } = uploadFile({ file, name: file.name, type, credentials });
            requests.push(xhr);
            return promise;
          })
          .then(file => store.dispatch(onSuccess(file)))
          .then(removeFinishedRequests(store))
          .catch(removeFinishedRequests(store));
      }

      case CANCEL_UPLOADS: {
        requests.forEach(xhr => {
          xhr.abort();
        });
        requests = [];
        return Promise.resolve();
      }

      default:
        return next(action);
    }
  };
}
